import { render } from "./matching-sidebar.vue?vue&type=template&id=12a5d2a4&scoped=true&ts=true"
import script from "./matching-sidebar.vue?vue&type=script&lang=ts"
export * from "./matching-sidebar.vue?vue&type=script&lang=ts"

import "./matching-sidebar.vue?vue&type=style&index=0&id=12a5d2a4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a5d2a4"]])

export default __exports__